import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { InputText, FormField } from 'ui';
import useInputPassword from './useInputPassword';

const InputPassword = ({ error, t, ...props }) => {
  const { visible, onVisible } = useInputPassword();

  return (
    <div className="input-password">
      <FormField
        errorMessage={error}
        error={!!error}
        label='Pasword'
        isLabelHidden
      >
        <InputText type={visible ? 'text' : 'password'} onClickIcon={onVisible} icon={visible ? 'visible' : 'visible-off'} {...props} />
      </FormField>
    </div>
  );
};

InputPassword.propTypes = {
  error: PropTypes.string,
};

InputPassword.defaultProps = {};

export default withTranslation('auth')(InputPassword);
